The tax detail of the product price.

This field is intended for budgeting and not to be directly shown to hirer.

Please contact SEEK before you use this field.
